import { create } from 'zustand';
import type { OnboardingMode } from '@repo/front-end-utils';

interface OnboardingSessionState {
  /**
   * Whether the wizard is **creating** this twin or **updating** an established one. Resolved once on
   * mount from the twin's `lifecycle_stage` (`resolveOnboardingMode`) and read by the wizard's
   * surfaces for copy only.
   */
  mode: OnboardingMode;
  setMode: (mode: OnboardingMode) => void;
}

/**
 * Onboarding-session state, held **in memory only** for the lifetime of a wizard session, and kept
 * out of `@repo/front-end-state` because the mode is a wizard concern, not a platform one (spec `twin-onboarding-onboarding-states`, FR2).
 *
 * There is deliberately **no `persist` middleware and no storage adapter**: the mode is derived from
 * the twin's `lifecycle_stage` on every mount, so persisting it would be a second source of truth
 * that can drift the moment the twin is activated elsewhere. It is also **presentation-only** — the
 * activation path must never read it (FR5); the delta guard stays the sole authority over what Go
 * Live does. Default `CREATE`, so a never-set store never reads as UPDATE.
 */
export const useOnboardingSessionStore = create<OnboardingSessionState>(set => ({
  mode: 'CREATE',
  setMode: mode => set({ mode }),
}));
